module.exports = __webpack_public_path__ + "img/a81abcd552e8e136904ed0860ebbcfe5.svg";